import React from 'react';
import { ArrowUp, ArrowDown, ChevronsUpDown } from 'lucide-react';

// Toggle helper for sort state {by, dir}. First click => asc, then toggles.
export function toggleSort(current, field) {
    if (current.by !== field) return { by: field, dir: 'asc' };
    return { by: field, dir: current.dir === 'asc' ? 'desc' : 'asc' };
}

export function SortableTh({ label, field, sort, onSort, align = 'left', className = 'p-4' }) {
    const active = sort?.by === field;
    const Icon = !active ? ChevronsUpDown : sort.dir === 'asc' ? ArrowUp : ArrowDown;
    const justify = align === 'right' ? 'justify-end' : align === 'center' ? 'justify-center' : 'justify-start';
    return (
        <th className={className}>
            <button
                type="button"
                onClick={() => onSort(toggleSort(sort, field))}
                data-testid={`sort-${field}`}
                className={`group inline-flex items-center gap-1.5 w-full ${justify} font-medium transition-colors hover:text-[var(--brand-burgundy)]`}
                style={{ color: active ? 'var(--brand-burgundy)' : 'inherit' }}
            >
                <span>{label}</span>
                <Icon className={`w-3.5 h-3.5 transition-opacity ${active ? 'opacity-100' : 'opacity-30 group-hover:opacity-70'}`} />
            </button>
        </th>
    );
}

export function TableSkeleton({ cols = 5, rows = 6 }) {
    return (
        <tbody data-testid="table-skeleton">
            {Array.from({ length: rows }).map((_, r) => (
                <tr key={`sk-row-${r}`} className="border-t border-[rgba(90,36,50,0.08)]">
                    {Array.from({ length: cols }).map((__, c) => (
                        <td key={`sk-cell-${r}-${c}`} className="p-4">
                            <div className="h-3.5 rounded bg-[var(--brand-rose)] animate-pulse" style={{ width: `${40 + ((r + c) % 4) * 15}%` }} />
                        </td>
                    ))}
                </tr>
            ))}
        </tbody>
    );
}
